// TODO: Move confirmation interfaces to this file
import { QuoteConfirmation as QuoteConfirmationC2F } from '@/coin-to-fiat/composables/types';
import { QuoteConfirmation as QuoteConfirmationF2C } from '@/fiat-to-coin/composables/types';
import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';

export const useQuoteConfirmationStore = defineStore('quote-confirmation', () => {
    const fiatToCoin = reactive<QuoteConfirmationF2C>({
        orderId: null,
        transactionId: null,
        paymentUrl: null,
        expiresAt: null
    });

    const coinToFiat = reactive<QuoteConfirmationC2F>({
        orderId: null,
        walletAddress: null,
        destinationTag: null
    });

    function setFiatToCoinConfirmation(confirmation: QuoteConfirmationF2C) {
        if (!confirmation) {
            fiatToCoin.orderId = null;
            fiatToCoin.transactionId = null;
            fiatToCoin.paymentUrl = null;
            fiatToCoin.expiresAt = null;
            return;
        }

        fiatToCoin.orderId = confirmation.orderId;
        fiatToCoin.transactionId = confirmation.transactionId;
        fiatToCoin.paymentUrl = confirmation.paymentUrl;
        fiatToCoin.expiresAt = confirmation.expiresAt;
    }

    function setOrderId(orderId: number): void {
        fiatToCoin.orderId = orderId;
    }

    function setCoinToFiatConfirmation(confirmation: QuoteConfirmationC2F) {
        if (!confirmation) {
            coinToFiat.orderId = null;
            coinToFiat.walletAddress = null;
            coinToFiat.destinationTag = null;
            return;
        }

        coinToFiat.orderId = confirmation.orderId;
        coinToFiat.walletAddress = confirmation.walletAddress;
        coinToFiat.destinationTag = confirmation.destinationTag;
    }

    return {
        coinToFiat: computed<QuoteConfirmationC2F>(() => coinToFiat),
        fiatToCoin: computed<QuoteConfirmationF2C>(() => fiatToCoin),
        setFiatToCoinConfirmation,
        setCoinToFiatConfirmation,
        setOrderId
    };
});
